<template>
  <div id="words" class="flex items-center justify-">
    <div class="word m-auto">{{ theme }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {

  name: 'ZoomingWords',

  data () {
    return {
    }
  },

  computed: {
    ...mapState([
      'themes'
    ]),

    theme: function () {
      return this.themes[1].name
    }
  },

  mounted: function () {

  }
}
</script>

<style lang="css" scoped>
  #words {
    font-family: "Courier New", Times, serif;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
  }

  .word {
    animation: ZOOM-TEXT 20s infinite;
    color: var(--color-green);
  }

  @keyframes ZOOM-TEXT {
    0%   {
      letter-spacing: 0;
      opacity: 0;
      font-size: 4vw;
      transform: rotateX(0);
      filter: blur(1px);
    }
    25% {
      opacity: 1;
    }
    50% {
      filter: blur(1px);
    }
    80% {
      opacity: 1;
      filter: blur(25px);
    }
    100% {
      letter-spacing: -3px;
      font-size: 16vw;
      /*text-shadow: 0 0 7vw rgba(14,255,0,0.5);*/
      filter: blur(50px);
      transform: rotateX(40deg);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ZoomingWords.vue